import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import LearningBook from "../assets/images/learning book.png";
import LearningVideo from "../assets/images/learning video.png";
import LearningPen from "../assets/images/learning pen.png";
import LearningIslamic from "../assets/images/learning islamic.png";
import LearningLove from "../assets/images/learning love.png";
import LearningPalette from "../assets/images/learning palette.png";
import LearningPercent from "../assets/images/learning percent.png";

import { useTranslation } from "react-i18next";

// Hero slide data
const learning1_data = {
  title: "home-learning-title1",
  desc: "home-learning-desc1",
  points: [
    {
      key: "home-learning-book",
      image: LearningBook,
    },
    {
      key: "home-learning-animation",
      image: LearningVideo,
    },
    {
      key: "home-learning-class",
      image: LearningPen,
    },
  ],
};

const learning2_data = {
  title: "home-learning-title2",
  desc: "home-learning-desc2",
  points: [
    {
      key: "home-learning-visual",
      image: LearningPalette,
    },
    {
      key: "home-learning-islamic",
      image: LearningIslamic,
    },
    {
      key: "home-learning-book2",
      image: LearningBook,
    },
    {
      key: "home-learning-love",
      image: LearningLove,
    },
    {
      key: "home-learning-price",
      image: LearningPercent,
    },
  ],
};

const HomeLearning = ({ type = 1 }) => {
  const { t } = useTranslation();

  const learningData = type === 1 ? learning1_data : learning2_data;

  return (
    <section className="home-learning">
      <Container>
        <Row>
          <Col md={12} lg={6} className="mb-4" key="Opening">
            <div className="content-desc">
              <h2 className="section-title" style={{ marginBottom: "1rem" }}>
                {t(learningData.title)}
              </h2>
              <p className="">{t(learningData.desc)}</p>
            </div>
          </Col>
          {learningData.points.map((item) => (
            <Col md={6} className="mb-4 learning-item" key={item.key}>
              <Card className="ripple-card border-0 h-100">
                <Card.Body className="">
                  <img src={item.image} alt={item.title} />
                  <div className="card-detail">
                    <Card.Title className="subsection-title">{t(`${item.key}.title`)}</Card.Title>
                    <Card.Text>{t(`${item.key}.desc`)}</Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HomeLearning;
